export default "__VITE_ASSET__Cpqmns4O__"